export default __webpack_public_path__ + "img/drops.9cfa89fc.svg";